module.exports = __webpack_public_path__ + "93443a87364054ff66b472c22a2655d0.svg";